import { Pagination as ReactBootstrapPagination } from 'react-bootstrap';
import React from 'react';
import { PaginationComponentProps } from 'react-ultimate-pagination';
import { OverlayTooltip, Placement } from '../overlay';
import { usePaginationRestriction } from './pagination-restriction-context';
import Icon from '../atoms/icon/icon';

export const Page = ({
  value,
  isActive,
  isDisabled,
  onClick,
}: PaginationComponentProps) => {
  const { maxAllowedPage, restrictionTooltip } = usePaginationRestriction();
  const isRestricted = maxAllowedPage != null && value > maxAllowedPage;
  const effectiveDisabled = isDisabled || isRestricted;

  const item = (
    <ReactBootstrapPagination.Item
      active={isActive}
      disabled={effectiveDisabled}
      onClick={effectiveDisabled ? undefined : onClick}
    >
      {value}
    </ReactBootstrapPagination.Item>
  );

  if (isRestricted && restrictionTooltip) {
    return (
      <OverlayTooltip text={restrictionTooltip} placement={Placement.Top}>
        <span style={{ display: 'inline-block', cursor: 'not-allowed' }}>
          {item}
        </span>
      </OverlayTooltip>
    );
  }

  return item;
};

export const Ellipsis = () => (
  <ReactBootstrapPagination.Ellipsis className="custom-ellipsis" />
);

export const FirstPageLink = ({
  isActive,
  isDisabled,
  onClick,
}: PaginationComponentProps) => (
  <ReactBootstrapPagination.First
    active={isActive}
    disabled={isActive || isDisabled}
    onClick={onClick}
  >
    <Icon identifier="chevron-double-left" />
  </ReactBootstrapPagination.First>
);

export const PreviousPageLink = ({
  isActive,
  isDisabled,
  onClick,
}: PaginationComponentProps) => (
  <ReactBootstrapPagination.Prev
    active={isActive}
    disabled={isActive || isDisabled}
    onClick={onClick}
  >
    <Icon identifier="chevron-left" />
  </ReactBootstrapPagination.Prev>
);

export const NextPageLink = ({
  isActive,
  isDisabled,
  onClick,
  value,
}: PaginationComponentProps) => {
  const { maxAllowedPage, restrictionTooltip } = usePaginationRestriction();
  const isRestricted = maxAllowedPage != null && value > maxAllowedPage;
  const effectiveDisabled = isActive || isDisabled || isRestricted;

  const item = (
    <ReactBootstrapPagination.Next
      active={isActive}
      disabled={effectiveDisabled}
      onClick={effectiveDisabled ? undefined : onClick}
    >
      <Icon identifier="chevron-right" />
    </ReactBootstrapPagination.Next>
  );

  if (isRestricted && restrictionTooltip) {
    return (
      <OverlayTooltip text={restrictionTooltip} placement={Placement.Top}>
        <span style={{ display: 'inline-block', cursor: 'not-allowed' }}>
          {item}
        </span>
      </OverlayTooltip>
    );
  }

  return item;
};

export const LastPageLink = ({
  isActive,
  isDisabled,
  onClick,
  value,
}: PaginationComponentProps) => {
  const { maxAllowedPage, restrictionTooltip } = usePaginationRestriction();
  const isRestricted = maxAllowedPage != null && value > maxAllowedPage;
  const effectiveDisabled = isActive || isDisabled || isRestricted;

  const item = (
    <ReactBootstrapPagination.Last
      active={isActive}
      disabled={effectiveDisabled}
      onClick={effectiveDisabled ? undefined : onClick}
    >
      <Icon identifier="chevron-double-right" />
    </ReactBootstrapPagination.Last>
  );

  if (isRestricted && restrictionTooltip) {
    return (
      <OverlayTooltip text={restrictionTooltip} placement={Placement.Top}>
        <span style={{ display: 'inline-block', cursor: 'not-allowed' }}>
          {item}
        </span>
      </OverlayTooltip>
    );
  }

  return item;
};

export const Wrapper: React.FC = (props) => (
  <ReactBootstrapPagination>{props.children}</ReactBootstrapPagination>
);
